import React from 'react'
import { useList, ListProps } from './useList'
import styles from './List.module.scss'
import DepartmentCard from 'components/DepartmentCard/DepartmentCard'
import AnimatedContainer from 'components/AnimatedContainer/AnimatedContainer'

const List: React.FC<ListProps> = (props: ListProps) => {
  const { departments, isAr, t } = useList(props)

  return (
    <div className={`${styles['departments-list']} row`}>
      {departments && departments.length ? (
        departments.map((department, index) => {
          const description = isAr
            ? department.definitionAr
            : department.definitionEn
          let shortDescription = ''

          if (
            description &&
            description.length > 0 &&
            description[0].children &&
            description[0].children.length > 0
          ) {
            const firstText = description[0].children[0].text
            shortDescription = `${firstText.substring(0, 100)}...`
          } else shortDescription = t('noDetails')

          return (
            <div
              key={`department-${department.id}-${index}`}
              className='col-12 col-md-6 col-lg-4 mb-3'
            >
              <AnimatedContainer animation='fadeIn' extraCssClasses='h-100'>
                <DepartmentCard
                  title={isAr ? department.nameAr : department.nameEn}
                  description={shortDescription}
                  url={department.slugAr}
                  image={department.logo}
                  isAr={isAr}
                  t={t}
                />
              </AnimatedContainer>
            </div>
          )
        })
      ) : (
        <div className={`col-12 text-center ${styles['no-data']} fs-4 fw-bold`}>
          {t('noData')}
        </div>
      )}
    </div>
  )
}

export default List
